angular.module('app').directive('apToolbar', ['$rootScope', '$transitions', 'AppRoutes', 'TransitionManager',
    function ($rootScope, $transitions, AppRoutes, TransitionManager) {
        'use strict';

        return {
            restrict: 'E',
            templateUrl: '/app/partials/toolbar/views/apToolbar.html',
            scope: true,
            transclude: false,
            link: function (scope) {

                scope.blankToolbar = {
                    IsActive: false,
                    BackToHome: { IsActive: false}
                };

                 function loadToolbar() {
                    if (!!$rootScope.hideToolbar) {
                        return;
                    }
                }

                loadToolbar();

                var stateChangeListener = $transitions.onSuccess({}, function onTransitionSuccess(transition) {
                    var toState = transition.targetState() || {};
                    var toStateName = toState && toState.name() || '';
                    var appRoute = _.find(AppRoutes, {state: toStateName});
                    scope.toolbarItem = (appRoute && appRoute.portalSettings && appRoute.portalSettings.toolbarItem);

                    if (scope.toolbarItem === 'blank') {
                        _.forEach(scope.notifications, function (toolbarButton) {
                            toolbarButton.IsActive = false;
                        });

                        scope.blankToolbar.IsActive = true;
                        scope.blankToolbar.BackToHome.IsActive = true;
                    }
                    else {
                        if (scope.blankToolbar.IsActive) {
                            resetToolbarState();
                        }
                    }
                });

                scope.$on('$destroy', function () {
                    stateChangeListener();
                });

                function resetToolbarState() {
                    scope.blankToolbar.IsActive = false;
                    scope.blankToolbar.BackToHome.IsActive = false;
                }

                function backToHome() {
                    resetToolbarState();
                    TransitionManager.transition({appRoute: 'dashboard'});
                }

                scope.backToHome = backToHome;
            }
        };
    }]);